/**
 *
 * @page 用户中心/资源库/模型库
 *
 **/

import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import { Button, Space } from 'antd';
import { useRouterTarget } from '&/utils/customHooks';
import useStoreState from '&/utils/customHooks/useStoreState';
import useEntDap from '&/utils/customHooks/useEntDap';
import ModelBase from '&/pages/resource-lib/ModelBase';
import MaterialChartlet from '&/pages/resource-lib/MaterialChartlet';
import Line from '&/pages/resource-lib/Line';

import './MaterialList.scss';

export default function MaterialList() {
    const { organization = {} } = useStoreState('appStore');

    const targetPage = useRouterTarget();

    const PAGE_TABS = [
        { name: intl.get('pages.modelBase') },
        { name: intl.get('userCenter.materialChartlet') },
        { name: '线条轮廓' },
    ];

    const [activeIdx, setActiveIdx] = useState(0);

    const entDap = useEntDap();

    const editAuthority =
        entDap !== 2 || (organization.roleFlag === 'admin' && entDap === 2);

    const lineBtnGroup = size => {
        return (
            <Space>
                <a
                    href="https://www.yuque.com/xiaoj-desvs/wux3o9/pa4i74dix7ie4qpb"
                    target="_blank"
                    rel="noreferrer"
                    className="native-link native-second">
                    {intl.get('material.featureIntroduction')}
                </a>
                <Button
                    type="primary"
                    onClick={() =>
                        targetPage({
                            pathname: `/user-center/${
                                entDap === 1
                                    ? 'personal-material'
                                    : 'enterprise-material'
                            }/upload-line`,
                        })
                    }
                    size={size}>
                    {intl.get('userCenter.uploadModel')}
                </Button>
            </Space>
        );
    };

    const btnGroup = (size = 'middle') => {
        if (activeIdx === 0) {
            return (
                <Space>
                    <a
                        href="https://www.yuque.com/xiaoj-desvs/wux3o9/li5xv3"
                        target="_blank"
                        rel="noreferrer"
                        className="native-link native-first">
                        {intl.get('material.modelingSpecifications')}
                    </a>
                    <a
                        href="https://www.yuque.com/xiaoj-desvs/wux3o9/eslkc1"
                        target="_blank"
                        rel="noreferrer"
                        className="native-link native-second">
                        {intl.get('material.featureIntroduction')}
                    </a>
                    <Button
                        type="primary"
                        onClick={() =>
                            targetPage({
                                pathname: `/user-center/${
                                    entDap === 1
                                        ? 'personal-material'
                                        : 'enterprise-material'
                                }/upload-model`,
                            })
                        }
                        size={size}>
                        {intl.get('userCenter.uploadModel')}
                    </Button>
                </Space>
            );
        }

        if (activeIdx === 2) {
            return lineBtnGroup(size);
        }

        const uploadMaterialUrl = `/user-center/${
            entDap === 1 ? 'personal-material' : 'enterprise-material'
        }/upload-material`;
        return (
            <Space>
                <a
                    href="https://www.yuque.com/xiaoj-desvs/wux3o9/bqu4z9u7houlumia"
                    target="_blank"
                    rel="noreferrer"
                    className="native-link native-first">
                    {intl.get('material.modelingSpecifications')}
                </a>
                <a
                    href="https://www.yuque.com/xiaoj-desvs/wux3o9/lyf5cw"
                    target="_blank"
                    rel="noreferrer"
                    className="native-link native-second">
                    {intl.get('material.featureIntroduction')}
                </a>
                {/*  <Button
                    type="primary"
                    onClick={() =>
                        targetPage({
                            pathname: uploadMaterialUrl,
                            search: { type: 2 },
                        })
                    }
                    size={size}>
                    {intl.get('userCenter.uploadChartlet')}
                </Button> */}
                <Button
                    type="primary"
                    size={size}
                    onClick={() =>
                        targetPage({
                            pathname: uploadMaterialUrl,
                            search: { type: 3 },
                        })
                    }>
                    {intl.get('userCenter.uploadMaterial')}
                </Button>
            </Space>
        );
    };

    const getActiveTabContent = () => {
        if (activeIdx === 0) {
            return (
                <ModelBase
                    btnGroup={btnGroup}
                    entDap={entDap}
                    editAuth={editAuthority}
                />
            );
        } else if (activeIdx === 1) {
            return (
                <MaterialChartlet
                    btnGroup={btnGroup}
                    entDap={entDap}
                    editAuth={editAuthority}
                />
            );
        } else {
            return (
                <Line
                    btnGroup={btnGroup}
                    entDap={entDap}
                    editAuth={editAuthority}
                />
            );
        }
    };

    return (
        <BasePageWrap
            type="card"
            className="material-list"
            tabs={PAGE_TABS}
            onTabChange={(el, i) => setActiveIdx(i)}
            headerRight={editAuthority && btnGroup()}>
            {getActiveTabContent()}
        </BasePageWrap>
    );
}
